import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, waLink } from "../lib/contact";

export const FloatingContact = () => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    className="fixed bottom-5 right-5 z-40 flex flex-col gap-3"
  >
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Scrie pe WhatsApp"
      className="grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.55)] transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle size={24} />
    </a>
    <a
      href={PHONE_TEL}
      data-testid="floating-call-button"
      aria-label="Sună acum"
      className="grid h-14 w-14 place-items-center rounded-full bg-anthracite text-oak shadow-[0_10px_30px_-6px_rgba(24,21,18,0.5)] transition-transform duration-300 hover:scale-110"
    >
      <Phone size={22} />
    </a>
  </motion.div>
);
